import React from "react";
import CustomDiv from "../../Shared/CustomDiv";
import { CardActionArea } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos";
import Text from "../../Shared/Text";
import classNames from "classnames";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import CustomButton from "../../Shared/CustomButton";
import { sliderListFn } from "../../Services/SliderList";
import { useMutation } from "react-query";
import { useState } from "react";
import { useEffect } from "react";
import { testimonialFn } from "../../Services/Testimonial";
import { bannerFn } from "../../Services/Banner";
import { allFiltersFn } from "../../Services/AllFilters/index,";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { API_URLS } from "../../Config/API_URLS";
import axiosInstance from "../../Config/axios";
import { Carousel } from "react-responsive-carousel";

const LandingPage = () => {
  const [open, setOpen] = useState(null);
  const [thumbnail, setThumbnail] = useState(false);
  const [detail, setDetail] = useState(false);
  const [data, setData] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [banners, setBanners] = useState([]);
  const [spices, setSpices] = useState([]);
  const [category, setCategory] = useState([]);
  const [recommandedProductss, setRecommandedProductss] = useState([]);
  const [topRatedProductss, setTopRatedProductss] = useState([]);
  const [mostViewedProductss, setMostViewedProductss] = useState([]);
  const [bannerss, setBannerss] = useState([]);
  const handleActiveHover = (id) => {
    setOpen(id);
  };
  const handleCloseHover = () => {
    setOpen(null);
  };
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
  };
  const recommandedProduct = () => {
    axiosInstance
      .post(API_URLS.recommandedProducts)
      .then((response) => {
        setRecommandedProductss(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const Banners = () => {
    axiosInstance
      .post(API_URLS.banners)
      .then((response) => {
        setBannerss(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const topRatedProduct = () => {
    axiosInstance
      .post(API_URLS.topRatedProducts)
      .then((response) => {
        setTopRatedProductss(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const mostViewedProduct = () => {
    axiosInstance
      .post(API_URLS.mostViewedProducts)
      .then((response) => {
        setMostViewedProductss(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getCategory = () => {
    axiosInstance
      .get(API_URLS.categoryList)
      .then((response) => {
        setCategory(response?.data?.data?.main_category_list);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const { mutate } = useMutation(sliderListFn, {
    onSuccess: (response) => {
      setData(response.data.data);
    },
  });
  const handleThaumbnailClick = (src) => {
    setThumbnail(src);
  };
  const { mutate: testimonial } = useMutation(testimonialFn, {
    onSuccess: (response) => {
      setTestimonials(response.data.data);
    },
  });

  const { mutate: banner } = useMutation(bannerFn, {
    onSuccess: (response) => {
      setBanners(response.data.data);
    },
  });
  useEffect(
    () => {
      mutate();
      testimonial();
      banner();
      recommandedProduct();
      topRatedProduct();
      mostViewedProduct();
      Banners();
    },
    // eslint-disable-next-line
    []
  );
  const navigate = useNavigate();
  const { mutate: allFilters } = useMutation(allFiltersFn, {
    onSuccess: (response) => {
      setSpices(response.data.data.product_list);
    },
  });
  useEffect(() => {
    getCategory();
  }, []);

  useEffect(
    () => {
      allFilters({
        category_id: 5,
        sub_category_id: "",
        brand_id: "",
        color_id: "",
        max_price: "",
        min_price: "",
        rating: "",
      });
    },
    // eslint-disable-next-line
    []
  );
  console.log("category", bannerss);
  return (
    <CustomDiv className="flex flex-col w-full !overflow-x-hidden">
      <div className="bg-blue-500">
        <div className="bg-white py-3 pt-2">
          <p className="text-start text-1xl text-gray-700 px-3 py-0 font-bold">
            Explore Categories
          </p>
          <div className="flex items-center gap-3 overflow-x-auto hide-scroll my-5 px-5">
            {category?.slice(0, 30).map((item) => {
              return (
                <div
                  onClick={() =>
                    navigate("/all-products", {
                      state: {
                        from: "category",
                        category: item.id,
                      },
                    })
                  }
                  className=" w-20"
                >
                  <img
                    src={item.image}
                    alt=""
                    className="h-16 w-16 rounded-full"
                  />
                  <div className="truncate">
                    <span className="px-5 text-center text-ellipsis overflow-hidden ">
                      {item.category}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex items-center gap-3 overflow-x-auto hide-scroll overflow-y-hidden my-5 px-5">
            {category?.slice(30).map((item) => {
              return (
                <div
                  onClick={() =>
                    navigate("/all-products", {
                      state: {
                        from: "category",
                        category: item.id,
                      },
                    })
                  }
                  className=" w-20"
                >
                  <img
                    src={item.image}
                    alt=""
                    className="h-16 w-16 rounded-full"
                  />
                  <div className="truncate">
                    <span className="px-5 text-center text-ellipsis overflow-hidden ">
                      {item.category}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        {data?.map((slider) => {
          return (
            <div key={slider.id} className="flex">
              <img src={slider.image} alt="" className="rounded w-full" />
            </div>
          );
        })}
      </div>

      {banners?.map((banner) => {
        return (
          <div className="py-2">
            <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
              {banner.category}
            </p>

            {banner?.banners?.map((i) => {
              return (
                <div
                  onClick={() =>
                    navigate("/all-products", {
                      state: {
                        from: "category",
                        category: i.id,
                      },
                    })
                  }
                >
                  <img
                    src={i.image}
                    alt=""
                    className=" px-4 py-3 rounded-[30px] w-[100%] "
                  />
                </div>
              );
            })}
          </div>
        );
      })}

      <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
        {spices?.map((product) => {
          return (
            <div onClick={() => navigate(`/product/${product?.id}`)}>
              <Card sx={{ width: 225, height: 380 }} className="!rounded-xl">
                <CardMedia
                  sx={{ height: 220, width: 220 }}
                  image={product.image}
                  title="green iguana"
                  className=" !bg-cover !my-2 !rounded-md"
                />
                <CardContent className="!px-2 !py-2">
                  <Typography
                    gutterBottom
                    variant=""
                    className="!text-start !truncate"
                    component="div"
                  >
                    <span className="text-gray-800 font_product !my-1 !text-ellipsis !overflow-hidden">
                      {product.title}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    className="!text-start !text-[10px]!my-5 "
                    color="text.secondary"
                  >
                    <div className="!text-[18px] mb-0 !text-gray-800">
                      {product.price}{" "}
                      <s className="!text-gray-400">
                        {product.discount_percent !== "0.0" ? (
                          <Text className="font-bold text-xl">
                            ₹{product.actual_price}
                          </Text>
                        ) : null}
                      </s>
                    </div>
                  </Typography>
                </CardContent>
                <CardActions className="!py-2">
                  <Button
                    size="small"
                    variant="outlined"
                    className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                  >
                    + ADD
                  </Button>
                </CardActions>
              </Card>
            </div>
          );
        })}
      </div>

      <CustomDiv className="flex flex-col justify-center items-center gap-1 my-10">
        <Text className="text-center text-xl font-semibold">
          Discount On Every Single Item On Our Site.
        </Text>
        <Text className="text-center text-blue-800 lg:text-4xl text-xl font-bold">
          <span className="text-blue-400 px-2 !font-semibold">
            OMG! JUST LOOK AT THE
          </span>
          GREAT DEALS!
        </Text>
        <span className="p-2 my-3 border-4 border-[#D32F2F] border-dashed rounded-full mx-3">
          <Text className="p-3 font-semibold text-center rounded-full text-white lg:text-xl gradient">
            HOW DOES IT FEEL, WHEN YOU SEE GREAT DISCOUNT DEALS FOR EACH
            PRODUCT?
          </Text>
        </span>
      </CustomDiv>
      <div className="py-1">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Sip & Chill{" "}
        </p>
        <div className="">
          <div className="flex gap-x-3 items-center justify-center">
            {category?.slice(3, 6).map((item) => {
              return (
                <img
                  src={item.image}
                  alt=""
                  className="object-cover py-2 rounded-[25px] w-[28.5%] h-[150px]"
                  onClick={() =>
                    navigate("/all-products", {
                      state: {
                        from: "category",
                        category: item.id,
                      },
                    })
                  }
                />
              );
            })}
          </div>
          <div className="flex gap-x-3 items-center justify-center">
            {category?.slice(10, 13).map((item) => {
              return (
                <img
                  src={item.image}
                  alt=""
                  className="object-cover py-2 rounded-[25px] w-[28.5%] h-[150px]"
                  onClick={() =>
                    navigate("/all-products", {
                      state: {
                        from: "category",
                        category: item.id,
                      },
                    })
                  }
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="px-3">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Recommended Products{" "}
        </p>
        <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
          {recommandedProductss?.product_list?.slice(0, 9)?.map((product) => {
            return (
              <div onClick={() => navigate(`/product/${product?.id}`)}>
                <Card sx={{ width: 225, height: 380 }} className="!rounded-xl">
                  <CardMedia
                    sx={{ height: 220, width: 220 }}
                    image={product.image}
                    title="green iguana"
                    className=" !bg-cover !my-2 !rounded-md"
                  />
                  <CardContent className="!px-2 !py-2">
                    <Typography
                      gutterBottom
                      variant=""
                      className="!text-start !truncate"
                      component="div"
                    >
                      <span className="text-gray-800 font_product !my-1 !text-ellipsis !overflow-hidden">
                        {product.title}
                      </span>
                    </Typography>
                    <Typography
                      variant="body2"
                      className="!text-start !text-[10px]!my-5 "
                      color="text.secondary"
                    >
                      <div className="!text-[18px] mb-0 !text-gray-800">
                        {product.price}{" "}
                        <s className="!text-gray-400">
                          {product.discount_percent !== "0.0" ? (
                            <Text className="font-bold text-xl">
                              ₹{product.actual_price}
                            </Text>
                          ) : null}
                        </s>
                      </div>
                    </Typography>
                  </CardContent>
                  <CardActions className="!py-2">
                    <Button
                      size="small"
                      variant="outlined"
                      className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                    >
                      + ADD
                    </Button>
                  </CardActions>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex flex-col">
        {data?.map((slider) => {
          return (
            <div key={slider.id} className="flex">
              <img src={slider.image} alt="" className="rounded w-full" />
            </div>
          );
        })}
      </div>

      <div className="py-2">
        {bannerss?.slice(15, 20)?.map((i) => {
          return (
            <div
              onClick={() =>
                navigate("/all-products", {
                  state: {
                    from: "category",
                    category: i.id,
                  },
                })
              }
            >
              <img
                src={i.image}
                alt=""
                className=" px-4 py-3 rounded-[30px] w-[100%] "
              />
            </div>
          );
        })}
      </div>

      <div>
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Top Rated Products
        </p>
      </div>
      <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
        {topRatedProductss?.product_list?.slice(0, 9)?.map((product) => {
          return (
            <div onClick={() => navigate(`/product/${product?.id}`)}>
              <Card sx={{ width: 225, height: 380 }} className="!rounded-xl">
                <CardMedia
                  sx={{ height: 220, width: 220 }}
                  image={product.image}
                  title="green iguana"
                  className=" !bg-cover !my-2 !rounded-md"
                />
                <CardContent className="!px-2 !py-2">
                  <Typography
                    gutterBottom
                    variant=""
                    className="!text-start !truncate"
                    component="div"
                  >
                    <span className="text-gray-800 font_product !my-1 !text-ellipsis !overflow-hidden">
                      {product.title}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    className="!text-start !text-[10px]!my-5 "
                    color="text.secondary"
                  >
                    <div className="!text-[18px] mb-0 !text-gray-800">
                      {product.price}{" "}
                      <s className="!text-gray-400">
                        {product.discount_percent !== "0.0" ? (
                          <Text className="font-bold text-xl">
                            ₹{product.actual_price}
                          </Text>
                        ) : null}
                      </s>
                    </div>
                  </Typography>
                </CardContent>
                <CardActions className="!py-2">
                  <Button
                    size="small"
                    variant="outlined"
                    className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                  >
                    + ADD
                  </Button>
                </CardActions>
              </Card>
            </div>
          );
        })}
      </div>
      <div className="py-2 ">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Morning Routing Covered{" "}
        </p>
        <div
          className="h-96 my-3"
          style={{
            background:
              "url('https://cdn.pixabay.com/photo/2017/10/05/13/50/watercolour-2819482__480.jpg')",
          }}
        >
          <div className="text-center text-[29px] text-green-700 px-3 py-2 font-bold">
            Mornings
            <br /> Made Easy{" "}
          </div>
          <div className="flex items-center px-4 justify-between py-8 overflow-x-auto gap-6 hide-scroll">
            {category?.slice(5).map((item) => {
              return (
                <img
                  src={item.image}
                  alt=""
                  className="h-[200px] !w-[200px] rounded-tr-3xl"
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex justify-center px-3 ">
        <Carousel
          autoPlay
          showStatus={false}
          showThumbs={false}
          showIndicators={false}
          showArrows={false}
        >
          {bannerss?.slice(20, 30).map((banner, index) => {
            return (
              <div
                key={index + 1}
                onClick={() =>
                  navigate("/all-products", {
                    state: {
                      from: "category",
                      category: banner.id,
                    },
                  })
                }
              >
                <img src={banner.image} alt="" className="h-[300px] w-full " />
              </div>
            );
          })}
        </Carousel>
      </div>
      <div>
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Most Viewed Products
        </p>
      </div>
      <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
        {mostViewedProductss?.product_list?.slice(0, 9)?.map((product) => {
          return (
            <div onClick={() => navigate(`/product/${product?.id}`)}>
              <Card sx={{ width: 225, height: 380 }} className="!rounded-xl">
                <CardMedia
                  sx={{ height: 220, width: 220 }}
                  image={product.image}
                  title="green iguana"
                  className=" !bg-cover !my-2 !rounded-md"
                />
                <CardContent className="!px-2 !py-2">
                  <Typography
                    gutterBottom
                    variant=""
                    className="!text-start !truncate"
                    component="div"
                  >
                    <span className="text-gray-800 font_product !my-1 !text-ellipsis !overflow-hidden">
                      {product.title}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    className="!text-start !text-[10px]!my-5 "
                    color="text.secondary"
                  >
                    <div className="!text-[18px] mb-0 !text-gray-800">
                      {product.price}{" "}
                      <s className="!text-gray-400">
                        {product.discount_percent !== "0.0" ? (
                          <Text className="font-bold text-xl">
                            ₹{product.actual_price}
                          </Text>
                        ) : null}
                      </s>
                    </div>
                  </Typography>
                </CardContent>
                <CardActions className="!py-2">
                  <Button
                    size="small"
                    variant="outlined"
                    className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                  >
                    + ADD
                  </Button>
                </CardActions>
              </Card>
            </div>
          );
        })}
      </div>
      <CustomDiv className="flex lg:flex-row flex-col gap-5 justify-between items-center px-[12%] gradient py-10 mx-3">
        <span className="text-white text-center">
          <Text className="font-semibold lg:text-2xl text-xl">
            SAVE UP TO 30% TO 40% OFF
          </Text>
          <Text className="font-bold lg:text-3xl text-xl">
            OMG! JUST LOOK AT THE GREAT DEALS!
          </Text>
        </span>
        <CustomButton className="!bg-white !p-3 !px-8 !text-black !rounded-full">
          View More
        </CustomButton>
      </CustomDiv>

      <CustomDiv className="bg-[rgb(242,251,254)] whitespace-nowrap overflow-x-auto hide-scroll m-3 flex gap-5 px-[8%]">
        {[
          "10% OFF",
          "Only $49",
          "Under @150",
          "Save Money",
          "80% OFF",
          "Free Shipping",
          "$79 Cashback",
          "Extra 10% OFF",
          "On Sale",
          "Free Shipping",
          "$79 Cashback",
          "Extra 10% OFF",
          "On Sale",
        ].map((item) => {
          return (
            <span className="flex justify-center items-center h-20 hover:bg-blue-300 hover:text-white transition-all duration-200 ease-linear p-3 px-5">
              <Text className="text-xl font-bold">{item}</Text>
            </span>
          );
        })}
      </CustomDiv>
      <CustomDiv className="lg:px-8 px-4 pb-3">
        <Slider {...settings} className="home-slider">
          {detail?.product_variant_value_list?.[0]?.varients_multiple_image?.map(
            (item) => {
              return (
                <CustomDiv
                  className="cursor-pointer"
                  onClick={() => {
                    handleThaumbnailClick(item.variant_image);
                  }}
                >
                  <img
                    src={item.variant_image}
                    alt=""
                    className={classNames(
                      "p-1 border border-zinc-200 ",
                      item.variant_image === thumbnail ? "border-zinc-400" : ""
                    )}
                  />
                </CustomDiv>
              );
            }
          )}
        </Slider>
      </CustomDiv>

      {/* <div className="py-2">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Cooking Needs
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0017/9234/4153/products/applepack6-overlay-overlay_1024x.png?v=1672588155"
          alt=""
          className="object-cover px-4 py-3 rounded-[30px] w-[100%] h-[360px]"
        />
      </div>
      <div className="py-1">
        <div className="flex px-3 py-2 justify-between">
          <div className="float-left text-start text-[17px] text-gray-700 font-bold">
            Kings Of Pantry
          </div>
          <div className="float-right font-bold text-blue-600">
            View All{" "}
            <ArrowForwardIosIcon className="!text-sm relative top-[-2px]" />{" "}
          </div>
        </div>
        <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://www.bigbasket.com/media/uploads/p/xxl/40279021_2-tata-coffee-grand-premium-coffee-powder-100-blend-instant-coffee-rich-in-aroma.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://www.bigbasket.com/media/uploads/p/xxl/40279021_2-tata-coffee-grand-premium-coffee-powder-100-blend-instant-coffee-rich-in-aroma.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      </div>
      <div className="py-3 ">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          The Mango Verse{" "}
        </p>
        <div
          className="h-96 my-3 object-cover"
          style={{
            background:
              "url('https://cdn.pixabay.com/photo/2017/01/19/21/59/watermelon-1993503_1280.png')",
            backgroundSize: "cover",
          }}
        >
          <div
            className="text-start text-white relative top-72 text-[35px] font-bold px-5"
            style={{ lineHeight: "30px" }}
          >
            The Mango <br /> Magic
          </div>
          <div className="float-right font-bold text-white relative top-60 text-[30px] px-5">
            <ArrowForwardIcon className="bg-white text-black !text-[40px] rounded-full" />
          </div>
        </div>
      </div>
      <div className="py-1 ">
        <p className="text-start text-[20px] text-gray-700 px-3 py-2 font-bold">
          Breackfast Zone{" "}
        </p>
        <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
          <div className="border-2 !bg-white border-indigo-600 h-[210px] rounded-2xl !w-[170px]">
            <img
              src="https://cdn.pixabay.com/photo/2016/02/11/20/06/baker-1194428_1280.jpg"
              alt=""
              className="h-[170px] rounded-t-2xl !w-[170px] rounded-b-[70px] relative top-[-1px]"
            />
            <div className="text-indigo-600 font-bold text-center pe-10 text-xl !w-[200px]">
              Breads
            </div>
          </div>
          <div className="border-2 !bg-white border-indigo-600 h-[210px] rounded-2xl !w-[170px]">
            <img
              src="https://cdn.pixabay.com/photo/2016/02/11/20/06/baker-1194428_1280.jpg"
              alt=""
              className="h-[170px] rounded-t-2xl !w-[170px] rounded-b-[70px] relative top-[-1px]"
            />
            <div className="text-indigo-600 font-bold text-center pe-10 text-xl !w-[200px]">
              Breads
            </div>
          </div>
          <div className="border-2 !bg-white border-indigo-600 h-[210px] rounded-2xl !w-[170px]">
            <img
              src="https://cdn.pixabay.com/photo/2016/02/11/20/06/baker-1194428_1280.jpg"
              alt=""
              className="h-[170px] rounded-t-2xl !w-[170px] rounded-b-[70px] relative top-[-1px]"
            />
            <div className="text-indigo-600 font-bold text-center pe-10 text-xl !w-[200px]">
              Breads
            </div>
          </div>
          <div className="border-2 !bg-white border-indigo-600 h-[210px] rounded-2xl !w-[170px]">
            <img
              src="https://cdn.pixabay.com/photo/2016/02/11/20/06/baker-1194428_1280.jpg"
              alt=""
              className="h-[170px] rounded-t-2xl !w-[170px] rounded-b-[70px] relative top-[-1px]"
            />
            <div className="text-indigo-600 font-bold text-center pe-10 text-xl !w-[200px]">
              Breads
            </div>
          </div>
          <div className="border-2 !bg-white border-indigo-600 h-[210px] rounded-2xl !w-[170px]">
            <img
              src="https://cdn.pixabay.com/photo/2016/02/11/20/06/baker-1194428_1280.jpg"
              alt=""
              className="h-[170px] rounded-t-2xl !w-[170px] rounded-b-[70px] relative top-[-1px]"
            />
            <div className="text-indigo-600 font-bold text-center pe-10 text-xl !w-[200px]">
              Breads
            </div>
          </div>
        </div>
      </div>
      <div className="py-1">
        <div className="flex px-3 py-2 justify-between">
          <div className="float-left text-start text-[20px] text-gray-700 font-bold">
            Emery Favourites
          </div>
          <div className="float-right font-bold text-blue-600">
            View All{" "}
            <ArrowForwardIosIcon className="!text-sm relative top-[-2px]" />
          </div>
        </div>
        <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://www.bigbasket.com/media/uploads/p/xxl/40279021_2-tata-coffee-grand-premium-coffee-powder-100-blend-instant-coffee-rich-in-aroma.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://www.bigbasket.com/media/uploads/p/xxl/40279021_2-tata-coffee-grand-premium-coffee-powder-100-blend-instant-coffee-rich-in-aroma.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      </div>
      <div className="py-2">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Brew, Sip & Munch{" "}
        </p>
        <img
          src="https://i.ytimg.com/vi/shjYmpKWG7g/maxresdefault.jpg"
          alt=""
          className="object-cover px-4 py-3 rounded-[30px] w-[100%] h-[220px]"
        />
      </div>
      <div className="flex items-center px-4 justify-between py-4 overflow-x-auto gap-4 hide-scroll">
        <img
          src="https://cdn.pixabay.com/photo/2018/03/10/07/09/wellness-3213366_1280.jpg"
          alt=""
          className="h-[200px] !w-[160px] rounded-3xl"
        />
        <img
          src="https://cdn.pixabay.com/photo/2017/01/18/20/10/pears-1990798_1280.png"
          alt=""
          className="h-[200px] !w-[160px] rounded-3xl"
        />
        <img
          src="https://cdn.pixabay.com/photo/2018/03/10/07/09/wellness-3213366_1280.jpg"
          alt=""
          className="h-[200px] !w-[160px] rounded-3xl"
        />
        <img
          src="https://cdn.pixabay.com/photo/2017/01/18/20/10/pears-1990798_1280.png"
          alt=""
          className="h-[200px] !w-[160px] rounded-3xl"
        />
        <img
          src="https://cdn.pixabay.com/photo/2018/03/10/07/09/wellness-3213366_1280.jpg"
          alt=""
          className="h-[200px] !w-[160px] rounded-3xl"
        />
      </div>
      <div className="py-2">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          Brands In Focus Today{" "}
        </p>
        <div className="flex items-center px-5 justify-between py-1 overflow-x-auto gap-4 hide-scroll">
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        </div>
        <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-4 hide-scroll">
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="py-1">
            <Card sx={{ maxWidth: 160 }} className="!rounded-3xl !w-[160px]">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="https://shreedashrath.com/wp-content/uploads/2021/04/glucon3.jpg"
                  alt="green iguana"
                  className="!w-[160px]"
                />
                <CardContent className="!px-0 !py-1">
                  <Typography gutterBottom component="div">
                    <span className="text-gray-700 font-bold">
                      Up to 33% off
                    </span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        </div>
      </div>
      <div className="py-1">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Stationery Store{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-3 rounded-[25px] w-[100%] h-[220px]"
        />
      </div>

      <div className="py-1">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Best Of Rice
        </p>
        <div className="flex gap-2 px-4">
          <div className="w-[35%]">
            <img
              src="https://cdn.shopify.com/s/files/1/0558/2687/4437/files/Mobile_coffee-tea-page-banner_600x600.jpg?v=1676502849"
              alt=""
              className="object-cover py-1 rounded-3xl w-[100%] h-[220px]"
            />
          </div>
          <div className="w-[63%]">
            <img
              src="https://aradbranding.com/en/uploads/topics/16749872775332.jpg"
              alt=""
              className="object-cover py-1 rounded-3xl w-[100%] h-[220px]"
            />
          </div>
        </div>
        <div className="flex gap-2 px-4">
          <div className="w-[35%]">
            <img
              src="https://cdn.shopify.com/s/files/1/0558/2687/4437/files/Mobile_coffee-tea-page-banner_600x600.jpg?v=1676502849"
              alt=""
              className="object-cover py-1 rounded-2xl w-32 h-32"
            />
          </div>
          <div className="w-[35%]">
            <img
              src="https://cdn.shopify.com/s/files/1/0558/2687/4437/files/Mobile_coffee-tea-page-banner_600x600.jpg?v=1676502849"
              alt=""
              className="object-cover py-1 rounded-2xl w-32 h-32"
            />
          </div>
          <div className="w-[35%]">
            <img
              src="https://cdn.shopify.com/s/files/1/0558/2687/4437/files/Mobile_coffee-tea-page-banner_600x600.jpg?v=1676502849"
              alt=""
              className="object-cover py-1 rounded-2xl w-32 h-32"
            />
          </div>
        </div>
      </div>
      <div className="py-4">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Deliciously Quick Deals{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-3 rounded-[25px] w-[100%] h-[340px]"
        />
      </div>
      <div className="py-2">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Melony Goodness{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-3 rounded-[25px] w-[100%] h-[340px]"
        />
      </div>
      <div className="py-1">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Summer Essentials{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-3 rounded-[25px] w-[100%] h-[220px]"
        />
      </div>
      <div className="py-2">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Explore More{" "}
        </p>
        <div className="flex items-center px-4 justify-between py-3 overflow-x-auto gap-4 hide-scroll">
          <img
            src="https://cdn.pixabay.com/photo/2015/05/30/01/18/vegetables-790022__480.jpg"
            alt=""
            className="object-cover rounded-lg w-32 h-[160px]"
          />
          <img
            src="https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_1280.jpg"
            alt=""
            className="object-cover rounded-lg w-32 h-[160px]"
          />
          <img
            src="https://cdn.pixabay.com/photo/2017/05/07/19/32/strawberry-2293337_1280.jpg"
            alt=""
            className="object-cover rounded-lg w-32 h-[160px]"
          />
          <img
            src="https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_1280.jpg"
            alt=""
            className="object-cover rounded-lg w-32 h-[160px]"
          />
          <img
            src="https://cdn.pixabay.com/photo/2017/05/07/19/32/strawberry-2293337_1280.jpg"
            alt=""
            className="object-cover rounded-lg w-32 h-[160px]"
          />
        </div>
      </div>
      <div className="py-1">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Fresheners And Repellents{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-2 rounded-[25px] w-[100%] h-[200px]"
        />
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-2 rounded-[25px] w-[100%] h-[200px]"
        />
      </div>
      <div className="py-2 ">
        <p className="text-start text-[19px] text-gray-700 px-3 py-2 font-bold">
          A Clean & Happy Home{" "}
        </p>
        <div
          className="h-96 my-3"
          style={{
            background:
              "url('https://img.freepik.com/free-vector/blue-cloudy-daylight-background-weather-design_33099-512.jpg')",
          }}
        >
          <div className="text-center ps-3 text-[29px] text-blue-700 px-3 py-2 font-bold">
            Mornings
            <br /> Made Easy{" "}
          </div>
          <div className="flex items-center px-4 justify-between py-8 overflow-x-auto gap-6 hide-scroll">
            <img
              src="https://cdn.pixabay.com/photo/2018/03/10/07/09/wellness-3213366_1280.jpg"
              alt=""
              className="h-[200px] !w-[200px] rounded-3xl"
            />
            <img
              src="https://cdn.pixabay.com/photo/2017/01/18/20/10/pears-1990798_1280.png"
              alt=""
              className="h-[200px] !w-[200px] rounded-3xl"
            />
            <img
              src="https://cdn.pixabay.com/photo/2018/03/10/07/09/wellness-3213366_1280.jpg"
              alt=""
              className="h-[200px] !w-[200px] rounded-3xl"
            />
            <img
              src="https://cdn.pixabay.com/photo/2017/01/18/20/10/pears-1990798_1280.png"
              alt=""
              className="h-[200px] !w-[200px] rounded-3xl"
            />
            <img
              src="https://cdn.pixabay.com/photo/2018/03/10/07/09/wellness-3213366_1280.jpg"
              alt=""
              className="h-[200px] !w-[200px] rounded-3xl"
            />
          </div>
        </div>
      </div>
      <div className="py-1">
        <img
          src="https://media.istockphoto.com/id/1166159013/photo/lifestyle-scene-of-rainy-weather-blue-umbrella-under-rainfall-banner-format.jpg?s=170667a&w=0&k=20&c=oAQAm5alhV_Hdyc2-i4OXwbqkgy63w-TJUosi8DIQoE="
          alt=""
          className="object-cover px-4 py-2 rounded-[25px] w-[100%] h-[200px]"
        />
      </div>
      <div className="py-1">
        <div className="flex px-3 py-1 justify-between">
          <div className="float-left text-start text-[20px] text-gray-700 font-bold">
            Newly Added
          </div>
          <div className="float-right font-bold text-blue-600">
            View All <ArrowForwardIosIcon className="!text-sm relative" />{" "}
          </div>
        </div>
        <div className="text-start px-4 text-gray-500">On Popular Demand</div>
        <div className="flex items-center px-5 justify-between py-5 overflow-x-auto gap-5 hide-scroll">
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://www.bigbasket.com/media/uploads/p/xxl/40279021_2-tata-coffee-grand-premium-coffee-powder-100-blend-instant-coffee-rich-in-aroma.jpg"
                title="green iguana"
                alt=""
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                alt=""
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://www.bigbasket.com/media/uploads/p/xxl/40279021_2-tata-coffee-grand-premium-coffee-powder-100-blend-instant-coffee-rich-in-aroma.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
          <div>
            <Card sx={{ maxWidth: 320 }} className="!rounded-xl">
              <CardMedia
                sx={{ height: 80 }}
                image="https://m.media-amazon.com/images/I/61XjnBPy0pL._SX522_.jpg"
                title="green iguana"
                alt=""
                className="!w-[170px] !mt-3 !h-24 !bg-cover"
              />
              <CardContent className="!px-2 !py-2">
                <Typography
                  gutterBottom
                  variant=""
                  className="!text-start"
                  component="div"
                >
                  <span className="text-gray-800 font_product">
                    Tata Coffee Grand Premium Jar
                  </span>
                </Typography>
                <Typography
                  variant="body2"
                  className="!text-start !text-[10px]"
                  color="text.secondary"
                >
                  <div className="pb-1">100GM</div>
                  <div className="!text-[18px] mb-0 !text-gray-800">
                    ₹220 <s className="!text-gray-400">₹220</s>
                  </div>
                </Typography>
              </CardContent>
              <CardActions className="!py-2">
                <Button
                  size="small"
                  variant="outlined"
                  className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                >
                  + ADD
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      </div>
      <div className="py-2">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Cremica Store{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-3 rounded-lg w-[100%] h-[340px]"
        />
      </div>
      <div className="py-1">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Pringles Store{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-3 rounded-[25px] w-[100%] h-[200px]"
        />
      </div>
      <div className="py-2">
        <p className="text-start text-[19px] text-gray-700 px-3 py-1 font-bold">
          Mr. Makhana Brand Store{" "}
        </p>
        <img
          src="https://cdn.shopify.com/s/files/1/0512/8827/7146/products/Single-Pack_cca6da0b-e259-41da-b19a-825bde344b8f.png?v=1677590450"
          alt=""
          className="object-cover px-4 py-3 rounded-3xl w-[100%] h-[340px]"
        />
      </div> */}

      {/* <CustomDiv className="flex overflow-x-auto hide-scroll m-3">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((item) => {
          return (
            <CustomDiv className="lg:w-1/2 h-80" key={item}>
              <img
                src={`https://source.unsplash.com/random/900×700/?food/${item}`}
                alt=""
                className="relative w-[295px] h-[295px] cursor-pointer"
              />
              <span
                onMouseEnter={() => handleActiveHover(item)}
                onMouseLeave={() => handleCloseHover(item)}
                className="relative overflow-hidden flex cursor-pointer justify-center items-center bottom-[19rem] pb-[108px] p-24 bg-white bg-opacity-0 hover:bg-opacity-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  fill="currentColor"
                  class="bi bi-instagram"
                  viewBox="0 0 16 16"
                  className={classNames(
                    "text-[#00BAF2] transition-all duration-700",
                    open === item
                      ? "scale-100 rotate-0"
                      : "scale-0 rotate-[-270deg]"
                  )}
                >
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                </svg>
              </span>
            </CustomDiv>
          );
        })}
      </CustomDiv> */}
    </CustomDiv>
  );
};

export default LandingPage;
